export const limitText = (text: string, maxCaracteres: number): string => {
  if (text.length > maxCaracteres) {
    return text.substring(0, maxCaracteres) + '...';
  }
  return text;
};
